import type { CustomizableCookie } from './types'

export const COOKIES: Record<CustomizableCookie, string> = {
  advertising: 'BM_Advertising',
  analytics: 'BM_Analytics',
  userExperience: 'BM_User_Experience',
}

export const GDPR_COOKIE_DURATION_IN_MONTHS = 6

export const ESSENTIAL_PURPOSE_ID = 'forthebr-qmYfF3Ry'

/**
 * CONSENT-CLEANUP ALLOW LIST — read before adding a cookie or storage item.
 *
 * When a user withdraws consent, every cookie and browser storage item (localStorage / sessionStorage) is deleted — EXCEPT the ones matched below.
 * See getOptionalTrackers, cleanBrowserCookies, cleanBrowserStorage, and the /delete-cookies server route for the consumers.
 *
 * Any cookie or storage item not matched by this list is wiped on the next consent withdrawal,
 * so a functional item that must survive opt-out has to be declared here, or it will be silently purged.
 *
 * Before adding a new entry, the Legal team MUST validate that the item can be classified as a functional (essential) tracker and is safe to persist regardless of consent.
 * Do not add an item here without that sign-off: keeping a non-functional tracker in this list would preserve it after a user withdraws consent, which is a GDPR / privacy risk.
 */
export const ESSENTIAL_ITEMS_NAMES = [
  'ab.optOut',
  '_cfuvid',
  '__cf_bm',
  'country_switch_clicked_at',
  'didomi_token',
  'didomi_dcs',
  'euconsent-v2',
  '__MCP_DEBUG_DATA__',
  'partner_promotion',
  '__paypal_storage__',
  'sessionid',
  'session_id',
  'showCatchupModal',
  'sourcingOpportunities_lastSearch',
  'tradein_au_accepted_offer',
  'utm_campaign',
  'utm_source',
  'visitor_id',
]
const ESSENTIAL_ITEMS_PREFIX = [
  'algolia',
  'backmarket-seller',
  'BM_',
  'bo_merchant',
  'bo_seller',
  'buyback_offer',
  'cf_',
  'cf.',
  'CHECKOUT_PRICE_UPDATES_',
  'com.grafana',
  'csrf',
  'didomi_token_',
  'favorites_pending-action',
  'oauth',
  'ory_kratos_session',
  'popup_state_',
]

export const ESSENTIAL_ITEMS_REGEX = new RegExp(
  `^(${ESSENTIAL_ITEMS_PREFIX.map((item) => item.replaceAll('.', '\\.')).join('|')})`,
  'i',
)

export const DISABLE_TRACKERS_COOKIE_NAME = 'BM_DISABLE_TRACKERS'
